import { ActionMeta } from "react-select5";
import { Option } from "../../../utils";
import { filterOptionDefault } from "@bonliva-crm/ui";

export const onCollapse =
  (collapsedGroups: string[], setCollapsedGroups: (groups: string[]) => void) =>
  (option: Option) => {
    const parent = option.value.split("|||")[0];
    if (collapsedGroups.some((x) => x === parent)) {
      setCollapsedGroups([...collapsedGroups.filter((x) => x !== parent)]);
    } else {
      collapsedGroups.push(parent);
      setCollapsedGroups([...collapsedGroups]);
    }
  };

export const isOptionSelected = (value: string[]) => (option: Option) => {
  if (!value) return false;

  const parent = option.value.split("|||")[0];
  if (value?.some((v) => v === `${parent}|||*`)) {
    return true;
  }

  return value?.some((v) => v === option.value);
};

export const isGroupSelected =
  (value: string[], allOpt: Option[], full: boolean) => (option: Option) => {
    if (!value || value?.length === 0) return false;

    const parent = option.parent ?? option.value.split("|||")[0];
    // console.log("parent", parent, option);
    // x.value.startsWith(`${parent}|||`)
    const allParentOptions = allOpt
      .filter((x) => x.value.startsWith(`${parent}|||`) || x.parent === parent)
      .map((x) => x.value);

    // console.log("allParentOptions", allParentOptions);
    if (allParentOptions.length > 0) {
      if (full && value.some((x) => x === parent)) {
        return true;
      }

      if (!full && allParentOptions?.some((v) => value.includes(v))) {
        return true;
      }
    }

    return value?.some((v) => v === option.value);
  };

export const filterOption =
  (collapsedGroups: string[], isSingle = false, allOptions?: Option[]) =>
  (option: Option, inputValue?: string) => {
    if (isSingle && filterOptionDefault(option, inputValue)) {
      return true;
    }
    const parent = option.value.split("|||")[0];

    if (inputValue) {
      const matchedParents = allOptions
        .filter((x) => filterOptionDefault(x, inputValue))
        .map((o) => o.value.split("|||")[0]);

      return (
        filterOptionDefault(option, inputValue) || matchedParents.includes(option.value)
      );
    } else {
      if (option.value === `${parent}|||*`) {
        return true;
      } else if (!option.value.includes("|||")) {
        return true;
      }
    }

    return collapsedGroups.some((x) => x === parent);
  };

export const isCollapsible = (option: Option) => !option.value.includes("|||");

export const isCollapsed = (collapsedGroups: string[]) => (option: Option) => {
  const parent = option.value.split("|||")[0];

  return !collapsedGroups.some((x) => x === parent);
};

export const isOptionStandAlone = (options: Option[]) => (option: Option) => {
  return (
    !option.value.includes("|||") &&
    !options.some((x) => x.value.startsWith(option.value) && x.value !== option.value)
  );
};

export const baseOnChange =
  (allOptions: Option[], onChange: (v: Option[]) => void, isSingle = false) =>
  (_newValues: Option[], actionMeta: ActionMeta<Option>) => {
    const { action, option } = actionMeta;
    let finalValues = _newValues;

    if (action === "select-option") {
      const parent = option.value.split("|||")[0];
      if (option.value === `${parent}`) {
        finalValues = [
          ...(_newValues.filter((x) => !x.value.startsWith(`${parent}|||`)) ?? [])
        ];
      } else {
        finalValues.push(option);
      }
    }

    if (action === "deselect-option") {
      const parent = option.value.split("|||")[0];
      const allParentOptions = !isSingle
        ? allOptions.filter(
            (x) => x.value.startsWith(`${parent}|||`) && x.value !== option.value
          )
        : [];
      if (option.value === `${parent}`) {
        finalValues = _newValues.filter((x) => !x.value.startsWith(`${parent}|||`));
      } else {
        finalValues = [..._newValues, ...allParentOptions].filter(
          (x) => x.value !== parent
        );
      }
    }

    onChange(finalValues.uniqueBy((x) => x.value));
  };

export const commonCollapsibleProps = {
  isCollapsible,
  hideSelectedOptions: false,
  controlShouldRenderValue: true,
  isSearchable: true,
  closeMenuOnSelect: false,
  menuChildrenPosition: "top" as const,
  maxMenuHeight: 400,
  menuPlacement: "bottom" as const,
  menuPortalTarget: document.body,
  styleProps: {
    menuPortal: { zIndex: 9999 },
    menu: {
      position: "absolute" as const,
      showBorder: true
    }
  }
};
